// src/utils/qualitative.js
import { clamp, toNumber } from './normalize';

function band(value, edges) {
  // returns the index of the first edge >= value
  for (let i = 0; i < edges.length; i++) if (value <= edges[i]) return i;
  return edges.length;
}

export function describePositiveImportance(v) {
  const x = clamp(toNumber(v), 0, 10);
  const idx = band(x, [1,3,5,7,9]);
  const labels = [
    'Irrelevant', 'Minor nice-to-have', 'Helpful', 'Important',
    'Very important', 'Decisive'
  ];
  return labels[idx];
}

export function describeDrawbackImportance(v) {
  const x = clamp(toNumber(v), 0, 10);
  const idx = band(x, [1,3,5,7,9]);
  const labels = [
    'Negligible', 'Minor annoyance', 'Moderate pain', 'Serious pain',
    'Critical blocker', 'Deal-breaker'
  ];
  return labels[idx];
}

export function describeSatisfactionLevel(v) {
  const x = clamp(toNumber(v), 0, 10);
  const idx = band(x, [2,4,6,8,10]);
  const labels = [
    'Severe pain', 'High friction', 'Workable', 'Generally smooth', 'Excellent'
  ];
  return labels[idx];
}

export function describeReasonNotChosenImportance(v) {
  const x = clamp(toNumber(v), 0, 10);
  const idx = band(x, [1,3,5,7,9]);
  const labels = [
    'Irrelevant', 'Minor factor', 'Contributing factor', 'Major factor',
    'Dominant factor', 'Decisive veto'
  ];
  return labels[idx];
}

export function describeJtbdImportance(v) {
  const x = clamp(toNumber(v), 0, 10);
  const idx = band(x, [2,4,6,8,10]);
  const labels = [
    'Very low', 'Low–moderate', 'Moderate', 'High', 'Very high'
  ];
  return labels[idx];
}

export function describeJtbdSatisfaction(v) {
  return describeSatisfactionLevel(v);
}

export function describeInsightSentimentIntensity(v) {
  const x = clamp(toNumber(v), 0, 10);
  const idx = band(x, [2,4,6,8,10]);
  const labels = [
    'Very weak', 'Mild', 'Moderate', 'Strong', 'Very strong'
  ];
  return labels[idx];
}
